import { useCallback } from 'react';

import { useOrderStatusQuery } from '@order/graphql';
import { useOrders } from '@order/Order';

/**
 * After submitting an order we refresh the orders and order status data.
 */
export const usePostOrderSubmitCallback = () => {
  const { fetchOrders } = useOrders();
  const [, fetchOrderStatus] = useOrderStatusQuery({ pause: true });

  return useCallback(() => {
    fetchOrders();
    fetchOrderStatus();
  }, [fetchOrderStatus, fetchOrders]);
};
